// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"71c0b888","982":"9720c57c"}[chunkId] + ".chunk.js";
};